<template>
  <div oncontextmenu="return false" class='position-fixed' @changePosition='changePosition' :style="{left:clientX+'px',top:clientY+'px'}">
    <div class='menu-box'>
        <div v-for="(menu,index) in menus" :key="menu.type+index">
          <div v-if="menu.type != 'divider'" class="text" @click="clickMenu(menu)">{{menu.name}}</div>
          <div v-else class="divider" ></div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      menus: {
        type: Array,
        default:[] 
      },
    },
    data() {
      return {
        clientX: 0,
        clientY:0
      }
    },
    methods: {
      changePosition(x,y) {
        let bottomlength = document.body.clientHeight - event.clientY;
        let menuHeight = 150; // 右键菜单的高度
        let Y = bottomlength > menuHeight ? event.clientY : event.clientY - menuHeight;
        this.clientX= x + 12,this.clientY=Y
      },
      clickMenu(menu) {
        this.$emit('menuClick',menu);
      }
    },
  }
</script>

<style scoped lang="less">
.position-fixed{
  position: fixed;
  height: auto;
  z-index: 9999;
  background: @content-bg;
  cursor: default;
}
.menu-box{
  border: 1px solid @line-strong-color;
  padding: 5px 0;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 hsla(0,0%,59%,.2);
}
.text {
  color: #606266;
  cursor: pointer;
  padding: 10px 20px;
  line-height: 1;
  transition: all .1s;
  font-size: 14px;
  
  &:hover{
    background-color: #ecf5ff;
    color: #66b1ff
  }
}
.divider{
  height: 0;
  border-bottom: 1px solid #e8e8e8;
}

</style>